<template>
    <component :is="display" />
</template>

<script>
export default {
    computed: {
        scope() {
            return this.$store.state.scope;
        },
        display() {
            if(this.scope.includes("root") || this.scope.includes("admin")) return () => import("./partner/PartnerList.vue");
            return null;
        },
    },
};
</script>
